import { useAuth } from '../../contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { CheckCircle, LogOut, Shield } from 'lucide-react';
import { toast } from 'sonner';

export function AuthStatus() {
  const { isAuthenticated, logout, checkAuthStatus } = useAuth();

  const handleLogout = () => {
    logout();
    toast.success('Successfully logged out');
  };

  const isCurrentlyAuthenticated = checkAuthStatus() && isAuthenticated;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Shield className="h-5 w-5" />
          Authentication Status
        </CardTitle>
        <CardDescription>
          Current device authorization status for Q&A service access
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium">Status:</span>
          <Badge variant={isCurrentlyAuthenticated ? "default" : "secondary"}>
            {isCurrentlyAuthenticated ? (
              <>
                <CheckCircle className="h-3 w-3 mr-1" />
                Authorized
              </>
            ) : (
              'Not Authorized'
            )}
          </Badge>
        </div>

        {isCurrentlyAuthenticated && (
          <div className="pt-2">
            <Button 
              variant="outline" 
              onClick={handleLogout}
              className="w-full"
            >
              <LogOut className="h-4 w-4 mr-2" />
              Logout
            </Button>
          </div>
        )}

        <div className="text-xs text-muted-foreground">
          {isCurrentlyAuthenticated 
            ? 'Your device is authorized to access the Q&A service. You can logout to revoke access.'
            : 'Your device needs authorization to access the Q&A service. Please authorize through the main interface.'
          }
        </div>
      </CardContent>
    </Card>
  );
}